import { JourneyType } from 'app/constants/Booking/BookingConstants'
import { isAfter } from 'date-fns'
import {
  flightNumberValidation,
  specitalInstructionsValidation,
} from 'helpers/regexValidation'
import * as yup from 'yup'

const outboundMinDateTime = new Date()
outboundMinDateTime.setMinutes(
  Math.ceil(outboundMinDateTime.getMinutes() / 15) * 15,
)

const optionalFlightNumberSchema = yup
  .string()
  .nullable()
  .test(
    'flight-number-format',
    'Please enter a valid flight number. E.g. BA123',
    (value) => {
      const normalisedValue = value?.trim() ?? ''

      if (!normalisedValue) {
        return true
      }

      return flightNumberValidation.test(normalisedValue)
    },
  )

const flightDetailsSchema = yup.object().shape({
  flightNumber: optionalFlightNumberSchema,
})

export default yup.object().shape({
  outbound: yup.object().shape({
    journeyTypeName: yup.object(),
    pickup: yup.object().required('Please select a pickup location'),
    dropOff: yup.object().when('journeyTypeName', {
      is: !JourneyType.AS_DIRECTED,
      then: (schema) => schema.required('Please supply a DropOff location'),
    }),
    services: yup
      .string()
      .oneOf(
        [
          null,
          '',
          ...Object.keys({ MeetAndGreet: 'Meet and Greet', None: 'None' }),
        ],
        'Additional Services required',
      )
      .label('Additional Services'),
    flightDetails: flightDetailsSchema,
    specialInstructions: yup
      .string()
      .nullable()
      .when({
        is: (val: any) => val.length > 0,
        then: yup
          .string()
          .matches(
            specitalInstructionsValidation,
            'There is an unsupported special character',
          )
          .label('Additional Service Instructions'),
      }),
  }),
  inbound: yup.object().shape({
    when: yup
      .date()
      .nullable()
      .test(
        'is-greater',
        'Please select a time after pickup',
        function (value) {
          const { outbound, journeyTypeName } = this.from[1].value

          if (
            journeyTypeName === JourneyType.RETURN &&
            !isAfter(value || new Date(), new Date(outbound.when))
          ) {
            return isAfter(value || new Date(), new Date(outbound.when))
          }
          return true
        },
      )
      .label('Return Date/Time'),
    services: yup
      .string()
      .oneOf(
        [
          null,
          '',
          ...Object.keys({ MeetAndGreet: 'Meet and Greet', None: 'None' }),
        ],
        'Additional Services is required',
      )
      .label('Additional Services'),
    flightDetails: flightDetailsSchema,
    specialInstructions: yup
      .string()
      .nullable()
      .when({
        is: (val: any) => val.length > 0,
        then: yup
          .string()
          .matches(
            specitalInstructionsValidation,
            'There is an unsupported character',
          )
          .label('Additional Service Instructions'),
      }),
  }),
})
